export const list = [
  { id: 1, name: "Professional Amount"},
  { id: 2, name: "Coaching Amount" },
  { id: 3, name: "Pay It Forward Suggested Amount" },
  { id: 4, name: "Extra Services Pricing" },
  { id: 5, name: "Group Sessions Pricing" },
  { id: 6, name: "Demonstrations Sessions Pricing" },
  
];

